export default __webpack_public_path__ + "static/media/party-beth-ani.52e4ce4c.gif";